import React from "react";
import PropTypes from "prop-types";
import { contactViewColumns } from "../../../pages/setup/components/managementcompanies/config/mgmtContactConfig";

const ViewContactRow = ({
  row,
  onRowClick,
  onSelectContact,
  selectedContact,
}) => {
  const { roleLabel, contact } = row;

  const handleRowClick = () => {
    if (!contact) return;
    if (onSelectContact) onSelectContact(contact);
    if (onRowClick) onRowClick(row);
  };

  return (
    <tr
      onClick={handleRowClick}
      className={`border-t cursor-pointer ${
        selectedContact && selectedContact.contactID === contact?.contactID
          ? "bg-cyan-100"
          : "bg-transparent hover:bg-cyan-50 hover:shadow-lg"
      }`}
    >
      {contactViewColumns.map((column, idx) => (
        <td
          key={idx}
          className={`${column.className} overflow-ellipsis text-nowrap`}
        >
          {column.accessor ? column.accessor(contact, roleLabel) : ""}
        </td>
      ))}
    </tr>
  );
};

ViewContactRow.propTypes = {
  row: PropTypes.shape({
    roleKey: PropTypes.string.isRequired,
    roleLabel: PropTypes.string.isRequired,
    contact: PropTypes.object,
  }).isRequired,
  onRowClick: PropTypes.func,
  onSelectContact: PropTypes.func,
  selectedContact: PropTypes.object,
};

export default ViewContactRow;
